<template>
  <v-container>
    <v-form>
      <v-container>
        <v-layout>
          <v-flex>
            <botones-validaciones></botones-validaciones>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
import BotonesValidaciones from "@/modules/configuration/commonsviews/BotonesProcesoValidaciones.vue";

export default {
  name: "proceso-validaciones",
  components: {
    BotonesValidaciones,
  },
  props: {},

  data() {
    return {};
  },
  computed: {},
  created() {
    this.$store.commit("tab_state", "Proceso");
  },
  methods: {},
};
</script>
